import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { temporaryBlockedRetryUrl } from '../../../pending-operation/shared/pending-operation-params'

@Injectable({
  providedIn: 'root',
})
export class ResolveTemporaryBlockedGuard {
  constructor(private readonly router: Router) {}

  public resolve(): Observable<string[] | null> | Promise<string[] | null> | string[] | null {
    const { state } = this.router.getCurrentNavigation()?.extras || {}
    return state?.[temporaryBlockedRetryUrl] ?? null
  }
}
